import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';
const PenaltyCreate=React.lazy(()=>import('./CreateForm'));
const PenaltyTable=React.lazy(()=>import('./Table'));

export const PenaltyConfigs = [
  {
    permittedRole: [RoutePermittedRole.corporateAdmin,RoutePermittedRole.vendor],
    path: '/onboard-corporate/penalty/create',
    element: <PenaltyCreate />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/onboard-corporate/penalty/listing',
    element: <PenaltyTable/>,
  },
 

];
